import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const BarChartDesignSettings = {
  'bar-chart-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['50%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  // Alignment
  'bar-chart-design-alignment': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'bar-chart-design-heading-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // margin
  'bar-chart-design-heading-margin': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  'bar-chart-design-comp-margin': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  // Typography
  'bar-chart-design-typography': {
    phone: getDefaultTypography('Body Small'),
    'phone-landscape': getDefaultTypography('Body Small'),
    tablet: getDefaultTypography('Body Large'),
    'tablet-landscape': getDefaultTypography('Body Large'),
    desktop: getDefaultTypography('Body Large'),
    tv: getDefaultTypography('Body Large'),
  },
  'bar-chart-design-heading-typography': {
    phone: getDefaultTypography('headline-small'),
    'phone-landscape': getDefaultTypography('headline-small'),
    tablet: getDefaultTypography('Headline Large'),
    'tablet-landscape': getDefaultTypography('Headline Large'),
    desktop: getDefaultTypography('Headline Large'),
    tv: getDefaultTypography('Headline Large'),
  },
  'bar-chart-design-x-axis-typography': {
    phone: getDefaultTypography('Body Small'),
    'phone-landscape': getDefaultTypography('Body Small'),
    tablet: getDefaultTypography('Body Large'),
    'tablet-landscape': getDefaultTypography('Body Large'),
    desktop: getDefaultTypography('Body Large'),
    tv: getDefaultTypography('Body Large'),
  },
  'bar-chart-design-values-typography': {
    phone: getDefaultTypography('Body Small'),
    'phone-landscape': getDefaultTypography('Body Small'),
    tablet: getDefaultTypography('Body Large'),
    'tablet-landscape': getDefaultTypography('Body Large'),
    desktop: getDefaultTypography('Body Large'),
    tv: getDefaultTypography('Body Large'),
  },
}
